export const tickerItems: string[] = [
  "顶流歌手巡演加场官宣，抢票当晚服务器被挤爆",
  "某热播剧大结局评分暴涨又暴跌，观众吵翻了",
  "综艺剪辑风波再起，节目组凌晨发文回应",
  "品牌营销短片被指看不懂，官微评论区已经沦陷",
  "选秀选手突然退赛，知情人曝出三处内幕细节",
  "老牌组合疑似合体，演唱会场馆路透照流出",
];

export const mastheadNav: { label: string; href: string }[] = [
  { label: "今日头条", href: "#headlines" },
  { label: "热门爆料", href: "#stories" },
  { label: "话题墙", href: "#topics" },
  { label: "热评现场", href: "#buzz" },
  { label: "热度榜", href: "#ranking" },
];

export const heroCover = {
  tag: "封面故事",
  title: "一档综艺的剪辑争议，如何演变成全网吃瓜现场",
  excerpt:
    "从一句被剪掉的对白，到节目组凌晨发文回应，短短三天里相关话题轮番上榜。我们把这波爆料的来龙去脉、关键时间点与网友两派观点，整理成这一期的封面观察。",
  image:
    "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20art%20with%20bold%20crimson%20and%20gold%20geometric%20shapes%20on%20warm%20cream%20paper%20texture%2C%20dramatic%20high%20contrast%20collage%2C%20grainy%20print%20finish%2C%20stylized%20abstract%20composition%20with%20no%20people%20and%20no%20text&width=900&height=1200&seq=heiliaoshe-cover-a1&orientation=portrait",
  author: "编辑部 · 阿七",
  date: "09.12",
  readTime: "约 6 分钟",
};

export const heroSideStories: {
  tag: string;
  title: string;
  image: string;
  heat: string;
}[] = [
  {
    tag: "恋情疑云",
    title: "新生代演员被拍深夜聚餐，团队回应：只是好友聚会",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20magazine%20illustration%20with%20soft%20rose%20and%20cream%20paper%20texture%2C%20bold%20geometric%20shapes%2C%20grainy%20print%20look%2C%20minimal%20no%20text&width=400&height=400&seq=heiliaoshe-side-b1&orientation=squarish",
    heat: "8.6万",
  },
  {
    tag: "品牌翻车",
    title: "某品牌营销短片翻车，网友：这波我确实看不懂",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20magazine%20illustration%20with%20deep%20crimson%20blocks%20and%20gold%20accents%20on%20cream%20paper%2C%20high%20contrast%20grainy%20print%20texture%2C%20no%20text&width=400&height=400&seq=heiliaoshe-side-b2&orientation=squarish",
    heat: "6.2万",
  },
  {
    tag: "选秀风波",
    title: "选秀选手退赛内幕曝光，知情人透露三处细节",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20magazine%20illustration%20with%20olive%20green%20and%20cream%20collage%20shapes%2C%20grainy%20print%20texture%2C%20bold%20minimal%20composition%2C%20no%20text&width=400&height=400&seq=heiliaoshe-side-b3&orientation=squarish",
    heat: "5.4万",
  },
  {
    tag: "港圈旧事",
    title: "老牌组合疑似合体，演唱会场馆路透照流出",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20magazine%20illustration%20with%20warm%20amber%20and%20charcoal%20geometric%20shapes%20on%20cream%20paper%2C%20grainy%20print%20retro%20texture%2C%20no%20text&width=400&height=400&seq=heiliaoshe-side-b4&orientation=squarish",
    heat: "4.9万",
  },
];

export const headlines: {
  tag: string;
  title: string;
  image: string;
  heat: string;
  comments: string;
  time: string;
}[] = [
  {
    tag: "深夜回应",
    title: "编剧深夜长文回应大结局争议，粉丝看完却更困惑了",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20thumbnail%20with%20crimson%20and%20cream%20shapes%2C%20grainy%20print%20texture%2C%20minimal%20bold%20composition%2C%20no%20text&width=320&height=320&seq=heiliaoshe-head-c1&orientation=squarish",
    heat: "12.4万",
    comments: "3821",
    time: "18 分钟前",
  },
  {
    tag: "直播带货",
    title: "直播间价格争议升级，平台已介入核实相关记录",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20thumbnail%20with%20amber%20gold%20and%20bone%20shapes%2C%20grainy%20print%20texture%2C%20minimal%20bold%20composition%2C%20no%20text&width=320&height=320&seq=heiliaoshe-head-c2&orientation=squarish",
    heat: "9.8万",
    comments: "2654",
    time: "42 分钟前",
  },
  {
    tag: "红毯造型",
    title: "红毯造型大翻车？造型师连夜发文解释设计思路",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20thumbnail%20with%20olive%20and%20cream%20shapes%2C%20grainy%20print%20texture%2C%20minimal%20bold%20composition%2C%20no%20text&width=320&height=320&seq=heiliaoshe-head-c3&orientation=squarish",
    heat: "7.1万",
    comments: "1930",
    time: "1 小时前",
  },
  {
    tag: "饭圈互撕",
    title: "两家粉丝因应援色开撕，路人心态：真的大可不必",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20thumbnail%20with%20charcoal%20and%20crimson%20shapes%2C%20grainy%20print%20texture%2C%20minimal%20bold%20composition%2C%20no%20text&width=320&height=320&seq=heiliaoshe-head-c4&orientation=squarish",
    heat: "6.5万",
    comments: "1487",
    time: "1 小时前",
  },
  {
    tag: "路透速递",
    title: "剧组路透照意外流出，妆容细节被网友反复放大研究",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20thumbnail%20with%20sand%20beige%20and%20crimson%20shapes%2C%20grainy%20print%20texture%2C%20minimal%20bold%20composition%2C%20no%20text&width=320&height=320&seq=heiliaoshe-head-c5&orientation=squarish",
    heat: "5.3万",
    comments: "1122",
    time: "2 小时前",
  },
];

export const topicTags: { label: string; count: number; tone: string }[] = [
  { label: "顶流塌房", count: 128, tone: "primary" },
  { label: "综艺名场面", count: 96, tone: "secondary" },
  { label: "红毯造型", count: 74, tone: "accent" },
  { label: "恋情疑云", count: 152, tone: "primary" },
  { label: "品牌翻车", count: 63, tone: "secondary" },
  { label: "直播带货", count: 88, tone: "accent" },
  { label: "选秀风波", count: 57, tone: "primary" },
  { label: "港圈旧事", count: 41, tone: "secondary" },
  { label: "饭圈互撕", count: 109, tone: "primary" },
  { label: "路透速递", count: 133, tone: "accent" },
  { label: "深夜回应", count: 72, tone: "secondary" },
  { label: "嗑糖现场", count: 35, tone: "accent" },
];

export const storyCards: {
  tag: string;
  title: string;
  image: string;
  comments: string;
  heat: string;
}[] = [
  {
    tag: "封面故事",
    title: "一档综艺的剪辑争议，如何演变成全网吃瓜现场",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20magazine%20card%20art%20with%20bold%20crimson%20and%20gold%20geometric%20shapes%20on%20warm%20cream%20paper%2C%20high%20contrast%20grainy%20print%20texture%2C%20no%20text&width=800&height=600&seq=heiliaoshe-card-d1&orientation=landscape",
    comments: "3821",
    heat: "12.4万",
  },
  {
    tag: "恋情疑云",
    title: "新生代演员被拍深夜聚餐，团队回应只是好友聚会",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20magazine%20card%20art%20with%20soft%20rose%20and%20cream%20collage%20shapes%2C%20high%20contrast%20grainy%20print%20texture%2C%20no%20text&width=800&height=600&seq=heiliaoshe-card-d2&orientation=landscape",
    comments: "2416",
    heat: "8.6万",
  },
  {
    tag: "品牌翻车",
    title: "某品牌营销短片翻车，网友表示这波确实看不懂",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20magazine%20card%20art%20with%20deep%20crimson%20blocks%20and%20gold%20accents%20on%20cream%20paper%2C%20grainy%20print%20texture%2C%20no%20text&width=800&height=600&seq=heiliaoshe-card-d3&orientation=landscape",
    comments: "1889",
    heat: "6.2万",
  },
  {
    tag: "选秀风波",
    title: "选秀选手退赛内幕曝光，知情人透露三处细节",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20magazine%20card%20art%20with%20olive%20green%20and%20cream%20geometric%20shapes%2C%20grainy%20print%20texture%2C%20no%20text&width=800&height=600&seq=heiliaoshe-card-d4&orientation=landscape",
    comments: "1534",
    heat: "5.4万",
  },
  {
    tag: "直播带货",
    title: "直播间价格争议升级，平台已介入核实相关记录",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20magazine%20card%20art%20with%20amber%20gold%20and%20charcoal%20shapes%20on%20cream%20paper%2C%20grainy%20print%20texture%2C%20no%20text&width=800&height=600&seq=heiliaoshe-card-d5&orientation=landscape",
    comments: "2654",
    heat: "9.8万",
  },
  {
    tag: "港圈旧事",
    title: "老牌组合疑似合体，演唱会场馆路透照流出",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20magazine%20card%20art%20with%20warm%20amber%20and%20charcoal%20retro%20geometric%20shapes%2C%20grainy%20print%20texture%2C%20no%20text&width=800&height=600&seq=heiliaoshe-card-d6&orientation=landscape",
    comments: "1207",
    heat: "4.9万",
  },
  {
    tag: "红毯造型",
    title: "红毯造型大翻车？造型师连夜发文解释设计思路",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20magazine%20card%20art%20with%20muted%20rose%20and%20gold%20shapes%20on%20bone%20paper%2C%20grainy%20print%20texture%2C%20no%20text&width=800&height=600&seq=heiliaoshe-card-d7&orientation=landscape",
    comments: "1930",
    heat: "7.1万",
  },
  {
    tag: "深夜回应",
    title: "编剧深夜长文回应结局争议，粉丝看完却更困惑了",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20magazine%20card%20art%20with%20dark%20crimson%20and%20cream%20shapes%20on%20warm%20paper%2C%20grainy%20print%20texture%2C%20no%20text&width=800&height=600&seq=heiliaoshe-card-d8&orientation=landscape",
    comments: "1487",
    heat: "6.5万",
  },
  {
    tag: "路透速递",
    title: "剧组路透照意外流出，妆容细节被网友反复放大研究",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20magazine%20card%20art%20with%20sand%20beige%20and%20crimson%20geometric%20shapes%2C%20grainy%20print%20texture%2C%20no%20text&width=800&height=600&seq=heiliaoshe-card-d9&orientation=landscape",
    comments: "1122",
    heat: "5.3万",
  },
];

export const hotComments: {
  name: string;
  avatar: string;
  text: string;
  likes: string;
  time: string;
  topic: string;
}[] = [
  {
    name: "瓜田里的老张",
    avatar:
      "https://readdy.ai/api/search-image?query=stylized%20editorial%20avatar%20illustration%20in%20warm%20cream%20and%20crimson%20duotone%2C%20abstract%20silhouette%20of%20a%20person%2C%20grainy%20print%20texture%2C%20no%20text&width=160&height=160&seq=heiliaoshe-avatar-e1&orientation=squarish",
    text: "理性吃瓜，先码住等一个官方回应。剪辑这事儿说白了就看完整版放不放出来，放了才有得聊。",
    likes: "2.4万",
    time: "12 分钟前",
    topic: "封面故事",
  },
  {
    name: "深夜刷手机的猫",
    avatar:
      "https://readdy.ai/api/search-image?query=stylized%20editorial%20avatar%20illustration%20in%20warm%20amber%20and%20charcoal%20duotone%2C%20abstract%20silhouette%20of%20a%20person%2C%20grainy%20print%20texture%2C%20no%20text&width=160&height=160&seq=heiliaoshe-avatar-e2&orientation=squarish",
    text: "信息量太大了，我先把时间线捋一遍。说实话两边都有道理，但带节奏的账号是真的多。",
    likes: "1.8万",
    time: "26 分钟前",
    topic: "恋情疑云",
  },
  {
    name: "只吃瓜不站队",
    avatar:
      "https://readdy.ai/api/search-image?query=stylized%20editorial%20avatar%20illustration%20in%20muted%20olive%20and%20cream%20duotone%2C%20abstract%20silhouette%20of%20a%20person%2C%20grainy%20print%20texture%2C%20no%20text&width=160&height=160&seq=heiliaoshe-avatar-e3&orientation=squarish",
    text: "其实最该被讨论的是品牌方那套营销逻辑，翻车不是意外，是必然。评论区比正片好看多了。",
    likes: "1.1万",
    time: "48 分钟前",
    topic: "品牌翻车",
  },
];

export const liveThread: { title: string; replies: string; heat: string }[] = [
  { title: "完整版剪辑到底放了什么？逐帧分析帖", replies: "826", heat: "爆" },
  { title: "造型师解释长文，你觉得站得住脚吗", replies: "512", heat: "热" },
  { title: "退赛选手这次算不算自毁前程", replies: "437", heat: "热" },
  { title: "老组合合体传闻，你还会买票吗", replies: "318", heat: "新" },
  { title: "直播间的价格差到底差在哪", replies: "265", heat: "新" },
];

export const ranking: { title: string; tag: string; heat: string; trend: string }[] = [
  { title: "综艺剪辑争议升级，节目组凌晨回应", tag: "封面故事", heat: "98.6", trend: "up" },
  { title: "编剧长文回应结局，粉丝却更困惑", tag: "深夜回应", heat: "94.2", trend: "up" },
  { title: "直播间价格争议，平台介入核实", tag: "直播带货", heat: "91.7", trend: "up" },
  { title: "新生代演员聚餐被拍，团队回应", tag: "恋情疑云", heat: "88.3", trend: "same" },
  { title: "红毯造型翻车，造型师连夜发文", tag: "红毯造型", heat: "85.1", trend: "down" },
  { title: "选秀选手退赛内幕曝光", tag: "选秀风波", heat: "82.4", trend: "up" },
  { title: "老牌组合疑似合体路透流出", tag: "港圈旧事", heat: "78.9", trend: "same" },
  { title: "两家粉丝应援色开撕，路人劝退", tag: "饭圈互撕", heat: "74.6", trend: "down" },
];

export const footerColumns: { title: string; links: { label: string; href: string }[] }[] = [
  {
    title: "栏目导航",
    links: [
      { label: "今日头条", href: "#headlines" },
      { label: "热门爆料", href: "#stories" },
      { label: "话题墙", href: "#topics" },
      { label: "热评现场", href: "#buzz" },
    ],
  },
  {
    title: "热门话题",
    links: [
      { label: "封面故事", href: "#topics" },
      { label: "恋情疑云", href: "#topics" },
      { label: "品牌翻车", href: "#topics" },
      { label: "路透速递", href: "#topics" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "投稿爆料", href: "#buzz" },
      { label: "内容声明", href: "#footer" },
      { label: "联系我们", href: "#footer" },
      { label: "热度榜说明", href: "#ranking" },
    ],
  },
];